<template lang="pug">
    div.launcher
        Dropdown(trigger="custom" :visible="visible" style="margin-left: 20px" v-click-outside="onClickOutside")
            Input.search-box(@input="handleInput" @on-focus="handleFocus" v-model="searchText" search :placeholder="searchPlaceHolder")
            DropdownMenu(slot="list")
                Spin(size="large" fix v-if="spinShow")
                Card
                    // 無搜尋結果時顯示提示
                    template(v-if="noResult")
                        span {{ $t('main.selectNotFoundText') }}

                    // 有特殊 DomainsWithAppProfile 結果時顯示
                    template(v-if="excludedFromFilteredResults")
                        DomainsWithAppProfileGroupView(:resourceResult="excludedFromFilteredResults")
                    
                    // 有其他類型資源時顯示（filteredResults 為非空）
                    template(v-else)
                    Row(v-for="resourceResult in filteredResults" :key="resourceResult.resourceType" v-if="resourceResult.resources.length > 0" style="margin-bottom: 15px;")
                        List.launcher-list
                            template(slot="header")
                                h3 {{ $i18n.t(`resourceType.${resourceResult.resourceType}`) }}
                                span.view-all-link(v-if="resourceResult.resources.length > 1")
                                    p(v-if="$store.state.queryGroupName == 'all' && !$store.getters.isAdmin") {{ resourceResult.total }} results
                                    LinkExtend(v-else :routeParams="setFuzzyResourceGroupName(resourceResult.fuzzyResource)") {{ viewAllText(resourceResult.total) }}
                                        Tag(v-if="$store.state.queryGroupName !== 'all'") {{$store.state.queryGroupName}}
                            ListItem.launcher-list-item(v-for="item, index in resourceResult.resources" :key="index")
                                .ivu-list-item-meta
                                    .ivu-list-item-meta-content
                                        .ivu-list-item-meta-title
                                            span {{ item._itemName }}
                                            span(style="margin-left: 15px;")
                                                Tag(v-for="tag in item.tags" :key="tag") {{ tag }}
                                        .ivu-list-item-meta-description
                                            span {{ item.description }}
                                template(slot="action")
                                    li
                                        LinkExtend(:routeParams="item._routeParams") 
                                            Tag {{item.groupName}} 
                                            | Manage
</template>
<script>
import { _debounce } from "@/libs/utils";
import { _searchResources } from "@/api/rest";
import vClickOutside from "v-click-outside";
import LinkExtend from "@/components/LinkExtend";
import DomainsWithAppProfileGroupView from "@/components/DomainsWithAppProfileGroupView";

import Vue from "vue";
Vue.component("LinkExtend", LinkExtend);
Vue.component("DomainsWithAppProfileGroupView", DomainsWithAppProfileGroupView);

export default {
    name: "ResourceLauncher",
    props: {},
    components: {
        LinkExtend,
        DomainsWithAppProfileGroupView,
    },
    data() {
        return {
            searchPlaceHolder: `Search anything. (Eg. Domains, ${this.$i18n.t(
                "resourceType.AppProfile"
            )}, Wafs, descriptions or tags...)`,
            searchText: "",
            results: [],
            visible: false,
            spinShow: false
        };
    },
    mounted() {},
    directives: {
        clickOutside: vClickOutside.directive
    },
    watch: {
        $route(to, from) {
            this.visible = false;
        }
    },
    methods: {
        searchDebounce() {},
        handleInput(queryValue) {
            // console.log(queryValue);
            if (queryValue.length > 0) {
                this.visible = true;
                this.searchDebounce(queryValue);
            } else {
                this.results = [];
                this.visible = false;
            }
        },
        handleFocus() {
            if (this.searchText.length > 0) {
                this.searchDebounce(this.searchText);
                this.visible = true;
            }
        },
        onClickOutside(event) {
            // console.log("Clicked outside. Event: ", event);
            this.visible = false;
        },
        viewAllText(total) {
            if (this.$store.state.queryGroupName == 'all') {
                return `view all ${total} results`;
            }
            return `view all ${total} results at `;
        },

        setFuzzyResourceGroupName(fuzzyResource) {
            return {
                ...fuzzyResource,
                query: {
                    ...fuzzyResource.query,
                    groupName: this.$store.state.queryGroupName,
                },
            };
        },
    },
    created() {
        var self = this;
        this.searchDebounce = _debounce(async function(queryValue) {
            try {
                // console.log(`Search for ${queryValue}`);
                self.spinShow = true;
                let result = await _searchResources(self.searchText, self.$store.state.queryGroupName);
                if (!result.data.success) throw new Error(result.data.message);
                self.results = result.data.data;
                self.spinShow = false;
            } catch (err) {
                console.log(err);
                self.spinShow = false;
            }
        });
    },
    computed: {
        noResult() {
            return (
                this.searchText &&
                this.searchText.length > 0 &&
                Array.isArray(this.results) &&
                this.results.every((e) => Array.isArray(e.resources) && e.resources.length === 0)
            );
        },
        excludedFromFilteredResults() {
            return this.results.find((item) => item.resourceType === "DomainsWithAppProfile");
        },
        filteredResults() {
            return this.results.filter((item) => item.resourceType !== "DomainsWithAppProfile");
        },
    },
};
</script>

<style scoped>
.search-box >>> ::-webkit-input-placeholder {
    font-style: italic;
    color: rgb(165, 165, 165) !important;
}
.search-box >>> ::-moz-placeholder {
    font-style: italic;
    color: rgb(165, 165, 165) !important;
}
.search-box >>> :-moz-placeholder {
    font-style: italic;
    color: rgb(165, 165, 165) !important;
}
.search-box >>> :-ms-input-placeholder {
    font-style: italic;
    color: rgb(165, 165, 165) !important;
}

.search-box >>> .ivu-input.ivu-input-default {
    background: rgba(45, 45, 45, 0.8);
    color: #ffffff !important;
}

.view-all-link {
    position: absolute;
    right: 10px;
    top: 16px;
    font-size: 13px;
}
.launcher {
    min-width: 500px;
}
.launcher-list {
    width: 100%;
}
.launcher-list-item >>> ul {
    line-height: 0px;
}

.launcher-list >>> .ivu-list-header {
    padding-bottom: 0px;
}

.launcher >>> .ivu-dropdown {
    width: 100%;
}

.launcher >>> .ivu-select-dropdown {
    z-index: 1000;
    top: 64px !important;
}

.launcher >>> .ivu-card-body {
    width: 800px;
    height: 600px;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/ResourceLauncher.vue